var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusHollowcomponent = function SvgPlusHollowcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 .5C5.47.5 1 4.97 1 10.5s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10Z",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.049 9.835v1.33h-3.385v3.384h-1.33v-3.384H6.95v-1.33h3.385V6.451h1.329v3.384h3.385Z"
  })));
};
export default SvgPlusHollowcomponent;